import type { FilterComponentProps } from '@/app/common/filters/core/filterComponentType.ts';
import type { FilterDataSearch } from '@/app/common/filters/core/filtersTypes.ts';
import FilterSearchList from '@/app/common/filters/types/search/FilterSearchList.tsx';

export const FilterSearch = ({ filter, handleFilterChanged }: FilterComponentProps) => {
  const { disabled } = filter;
  const filterData = filter.data as FilterDataSearch;

  const handleToggle = (valueClicked: string) => {
    const updatedOptions = filterData.options.map((option) => ({
      ...option,
      selected: option.value === valueClicked ? !option.selected : option.selected,
    }));
    handleFilterChanged([{ ...filter, data: { ...filter.data, options: updatedOptions } }]);
  };

  if (!filterData.options) return null;

  return (
    <FilterSearchList
      name={`${filter.name}_search`}
      placeholder={filterData.placeholder}
      noResultsText={filterData.noResultsLabel}
      options={filterData.options}
      anyValue={filterData.anyValue}
      disabled={disabled}
      onToggle={handleToggle}
    />
  );
};
